import { decodeJWT } from './clientRestrictions';

export const USER_ROLES = {
  ACCOUNTS: 'client-accounts',
  OPERATIONS: 'client-operations',
} as const;

/**
 * Client access roles are stored per credential_users link (the login), not on
 * the shared user account, because multiple team-member logins map to the same
 * user. Origin embeds the resolved link roles in the JWT at login as
 * `clientRoles`, so we read them from the access token rather than the user.
 *
 * Impersonation tokens carry `roles: ['user-impersonation']` and no
 * `clientRoles`, so an impersonating admin gets full access (empty roles).
 */
export const getClientRoles = (accessToken?: string): string[] => {
  if (!accessToken) return [];
  const decoded = decodeJWT(accessToken);
  const roles = decoded?.clientRoles;
  return Array.isArray(roles) ? roles : [];
};

export const isAccountsRole = (accessToken?: string): boolean =>
  getClientRoles(accessToken).includes(USER_ROLES.ACCOUNTS);

export const isOperationsRole = (accessToken?: string): boolean =>
  getClientRoles(accessToken).includes(USER_ROLES.OPERATIONS);
